import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { MerchantPartyForm } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantParty/MerchantPartyForm";
import { MerchantPartyLegalEntity } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantParty/MerchantPartyLegalEntity";
import { MerchantPartySkeleton } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantParty/MerchantPartySkeleton";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PartyType } from "Infrastructure/Api/Api";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const RESOURCES =
  Resources.Hunter.Merchants.CompleteRegistration.MerchantCompany;

type Props = {
  formId: string;
  merchantPublicID: string;
  onAfterSubmit: () => void;
};

export const MerchantParty = ({
  formId,
  merchantPublicID,
  onAfterSubmit,
}: Props) => {
  const { t } = useResource();
  const { data: merchantData, isLoading } =
    useGetMerchantQuery(merchantPublicID);

  if (isLoading) {
    return <MerchantPartySkeleton />;
  }

  if (!merchantData) {
    return <ErrorText>{t(RESOURCES.LoadingError)}</ErrorText>;
  }

  const { party } = merchantData;
  const isSelfEmployed = merchantData.party.type === PartyType.SelfEmployed;

  if (isSelfEmployed) {
    return (
      <MerchantPartyForm
        formId={formId}
        party={party}
        merchantPublicID={merchantPublicID}
        onAfterSubmit={onAfterSubmit}
      />
    );
  }

  return <MerchantPartyLegalEntity party={party} />;
};
